import { useParams } from "react-router-dom";
import ReportPrintView from "./print/ReportPrintView";

const ReportPrintPage = () => {
  const {
    clientNameParam,
    propertyMasterId,
    inspectionRefnumber,
  } = useParams();

  return (
    <ReportPrintView
      clientNameParam={clientNameParam}
      propertyMasterId={propertyMasterId}
      inspectionReferenceNumber={inspectionRefnumber}
    />
  );
};

export default ReportPrintPage;
